import React from 'react'

import { useAnalysis } from 'redux/hooks/Analyses'

import Version1 from './Version1'
import Version2 from './Version2'

interface AnalysisVersionFacadeProps {
  id: string
}

/**
 * The analysis's evidence, whichever generation produced it. Each version
 * owns its own dialogs, so the page never asks which one it shows.
 */
const AnalysisVersionFacade = ({ id }: AnalysisVersionFacadeProps) => {
  const { analysis } = useAnalysis(id)

  if (!analysis) return null

  return analysis.version === 1 ? (
    <Version1 analysis={analysis} />
  ) : (
    <Version2 analysis={analysis} />
  )
}

export default AnalysisVersionFacade
